import React from 'react';
import { Checkbox, CheckboxProps } from 'antd';
import './TopAlignCheckbox.scss';

interface TopAlignCheckboxProps {
  value?: string | boolean;
  checked?: boolean;
  onChange?: (checked: boolean | string) => void;
  children?: React.ReactNode;
  id?: string;
}

const TopAlignCheckbox: React.FC<TopAlignCheckboxProps> = ({
  value,
  checked = false,
  onChange,
  children,
  id
}) => {
  const handleChange: CheckboxProps['onChange'] = (e) => {
    // If value is a string (used in Checkbox.Group), pass the value
    // Otherwise, pass the checked state (used standalone)
    // if (typeof value === 'string') {
    //   onChange?.(value);
    // } else {
    onChange?.(e.target.checked);
    // }
  };

  return (
    <div className="top-align-checkbox-wrapper" id={id}>
      <Checkbox
        checked={checked}
        onChange={handleChange}
        className="top-align-checkbox"
        value={value}
      />
      <div
        className="top-align-checkbox-content"
        onClick={() => onChange?.(!checked)}
        style={{ cursor: 'pointer' }}
      >
        {children}
      </div>
    </div>
  );
};

export default TopAlignCheckbox;

